;(function() {
  'use strict'

  angular.module('core.filters').filter('escapeHtml', filter)

  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
  }

  /* @ngInject */
  function filter() {
    return function(string) {
      return String(string).replace(/[&<>"'\/]/g, function(s) {
        return entityMap[s]
      })
    }
  }
})()
